module.exports = __webpack_public_path__ + "images/emoji/city_sunrise.b25c59818f605880717a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/city_sunrise.png
// module id = fk5w
// module chunks = 13